import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import f1 from "../assets/foto/ale-armato.jpeg";
import f2 from "../assets/foto/alberto-armato.jpg";
import f3 from "../assets/foto/cli-civile.jpg";
import f4 from "../assets/foto/grp-civile.jpg";
import f5 from "../assets/foto/didattica-1.jpg";
import f6 from "../assets/foto/didattica-2.jpg";

function Ricostruzione() {
  const { t } = useTranslation();

  return (
    <div className="ricostruzione-detail-section">
      <div className="base-text-container text-center">
        <h2 className="base-title">{t("ricostruzione.title")}</h2>
      </div>

      <div className="md:grid md:grid-cols-2 gap-8 items-center">
        <div className="order-1 md:order-1">
          <div className="ricostruzione-detail-text">
            <p className="base-subtitle">
              {t("ricostruzione.subtitles.whatIs")}
            </p>
            {t("ricostruzione.texts.whatIs", { returnObjects: true }).map(
              (text, index) => (
                <p key={index} className="mb-4">
                  {text}
                </p>
              ),
            )}
          </div>
        </div>
        <div className="order-2 md:order-2 ricostruzione-detail-grid">
          <img
            className="ricostruzione-detail-grid-img"
            src={f2}
            alt="foto-ricostruzione"
          />
          <img
            className="ricostruzione-detail-grid-img"
            src={f3}
            alt="foto-ricostruzione"
          />
        </div>

        <div className="order-3 md:order-4">
          <div className="ricostruzione-detail-text">
            <p className="base-subtitle">
              {t("ricostruzione.subtitles.whoWeAre")}
            </p>
            {/* <p className="mb-4">{t("ricostruzione.texts.whoWeAre")}</p> */}
            {t("ricostruzione.texts.whoAreWe", { returnObjects: true }).map(
              (text, index) => (
                <p key={index} className="mb-4">
                  {text}
                </p>
              ),
            )}
          </div>
        </div>
        <div className="order-4 md:order-3">
          <div className="ricostruzione-detail-grid ">
            <img
              className="ricostruzione-detail-grid-img"
              src={f4}
              alt="foto-ricostruzione"
            />
            <img
              className="ricostruzione-detail-grid-img"
              src={f1}
              alt="foto-ricostruzione"
            />
          </div>
        </div>

        <div className="order-5 md:order-5">
          <div className="ricostruzione-detail-text">
            <p className="base-subtitle">
              {t("ricostruzione.subtitles.howTo")}
            </p>
            {/* <p className="mb-4">{t("ricostruzione.texts.howTo")}</p> */}
            {t("ricostruzione.texts.howToStart", { returnObjects: true }).map(
              (text, index) => (
                <p key={index} className="mb-4">
                  {text}
                </p>
              ),
            )}
          </div>
        </div>
        <div className="order-6 md:order-6 mb-4">
          <div className="ricostruzione-detail-grid">
            <img
              className="ricostruzione-detail-grid-img"
              src={f5}
              alt="foto-ricostruzione"
            />
            <img
              className="ricostruzione-detail-grid-img"
              src={f6}
              alt="foto-ricostruzione"
            />
          </div>
        </div>
        <div className="base-subtitle order-7 md:order-7 col-span-2 text-center">
          {t("ricostruzione.texts.CTA")}
          <Link to="/contatti" className="base-link font-bold">
            {t("header.contatti")}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Ricostruzione;
